import React from 'react';
import PropTypes from 'prop-types';
import {DrawerHandle} from '@learningblocks/protocol-components';
import {GlossaryProvider} from '@learningblocks/storybook-components';
import {Image, LogEvent} from '@learningblocks/shared-components';
import GlossaryIcon from './Glossary.Icon.svg';

export function NotebookSectionsHeader(props) {

  const {onOpenGlossary} = React.useContext(GlossaryProvider.Context);

  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onOpenGlossary('');
  };

  return (
    <div className='notebook-sections__header'>
      <DrawerHandle />
      <span className='title'>
        {(props.level)?(
          <h6 style={{transformText: "uppercase"}}>{props.level}</h6>
        ):null}
        <h5>Photosynthesis and Cellular Respiration</h5>
      </span>
      <LogEvent
        logEventProps={{
          event_type: "sim_glossary_btn clicked",
          event_schema: "track"
        }}
        actionProps={{ onClick: { action: 'click' } }}
        elementType="button"
      >
        <span className='glossaryButton' onClick={onClick}>
          <Image src={GlossaryIcon} alt='glossary icon' />
          <h5>Glossary</h5>
        </span>
      </LogEvent>
    </div>
  );
}
NotebookSectionsHeader.propTypes = {
  level: PropTypes.string
};
